export type { SearchParamsLike, SearchParamsRecord } from "./tracking.types";
export { TrackingQueryParamsBootstrap } from "./TrackingQueryParamsBootstrap/TrackingQueryParamsBootstrap";
export {
  appendTrackingSearch,
  extractTrackingQueryParams,
} from "./trackingQueryParams/trackingQueryParams";
export {
  getEffectiveTrackingQueryParams,
  persistTrackingQueryParams,
} from "./trackingPersistence/trackingPersistence";
export {
  AGELESS_TRACKING_HEADER_PREFIX,
  getTrackingHeaders,
} from "./trackingHeaders/trackingHeaders";
export {
  isPaidAdArrival,
  isPaidAdMedium,
  PAID_UTM_MEDIUMS,
} from "./trackingPaidTraffic/trackingPaidTraffic";
